import React from "react";
import { Loader } from './LoadingWheel.styles' 

const LoadingWheel = (props) => {
    return (
        <Loader />
    );
  };
  
  export default LoadingWheel;